



import Vue from 'vue'
var pjson = require('../../package.json')
console.log(pjson.version)

export default Vue.extend({
  name: 'AppInfo',
  data () {
    return {
      version: pjson.version
    }
  }
})
